import type { RootState } from 'state';
import type { WebDestinationsState } from '../slice';

function getWebDestinations(state: RootState): WebDestinationsState['value'] {
  const { value } = state.dataService.destinations.webDestinations;
  return value;
}

export default getWebDestinations;
